import { useBranch } from "@/contexts/BranchContext";

/**
 * Required Branch select for master forms (Projects, Clients, Vendors, Members,
 * Items, Bank Ledger, etc.). Pre-fills with the global active branch as a
 * sensible default; user can change before save.
 */
export function BranchSelect({ value, onChange, testid = "form-branch-select", required = true, className = "" }) {
  const { branches, active } = useBranch();
  const list = branches || [];
  return (
    <select
      data-testid={testid}
      required={required}
      value={value || ""}
      onChange={(e) => {
        const b = list.find((x) => x.id === e.target.value);
        onChange(e.target.value, b ? (b.branch_name || b.name || "") : "");
      }}
      className={`w-full border border-slate-300 bg-white px-3 py-2.5 text-sm focus:outline-none focus:border-[#F97316] ${className}`}
    >
      <option value="">— Select Branch{required ? " *" : ""} —</option>
      {list.map((b) => (
        <option key={b.id} value={b.id}>
          {b.branch_name || b.name || b.id}
          {active && active.id === b.id ? " (active)" : ""}
        </option>
      ))}
    </select>
  );
}

export default BranchSelect;
